var _style, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMisedOpportunity01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#AEB7BF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M272.2,16c9,1.6,18.2,2.7,27.1,4.7c67.3,15.6,118.8,72.1,127.9,140.6c7,52.1-7.5,97.8-42.5,136.9 c-15.1,16.8-25.9,35.7-29.4,58.1c-1.3,8.2-1,16.6-2.2,24.7c-4.4,28.2-27.5,48-56.1,48.1c-24.7,0.1-49.4,0.1-74.2,0 c-31.7-0.1-56.4-24.7-56.8-56.5c-0.4-27.8-9.8-51.9-28.9-72.2c-25.1-26.7-40.5-58.2-44.9-94.5c-9.6-78.8,34.3-150.7,105.9-178.6 c14.8-5.8,30.2-9.2,46-10.5c1.2-0.1,2.4-0.5,3.6-0.8C255.9,16,264.1,16,272.2,16z M260,391.6c11.7,0,23.5,0,35.2,0 c13.5,0,20.5-7.4,21.3-20.7c0.7-10.9,1.9-21.8,4.3-32.4c6-26.3,20.2-48,38.2-67.9c35.2-39.1,42.5-97.7,18.5-144.6 C349.9,72,292.7,44.4,232,56.5c-66,13.1-112.5,76.2-101.9,148c4,27.5,16.4,50.9,35.3,71.1c25.2,27,37.7,59.3,38.3,96.2 c0.2,12.1,8,19.8,20.2,19.8C235.9,391.6,247.9,391.6,260,391.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M218.6,496.8c-1.3-0.6-2.6-1.1-3.8-1.7c-7.9-3.6-12.5-12.1-10.9-20.3c1.6-8.7,8.8-15.4,17.6-15.5 c25.7-0.2,51.3-0.2,77,0c8.8,0.1,16,6.8,17.6,15.5c1.5,8.3-3,16.8-11,20.3c-1.3,0.6-2.6,1.1-3.8,1.7 C273.7,496.8,246.2,496.8,218.6,496.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M282.9,129.4c-1.8,30.5-3.5,60.9-5.3,91.4c-0.2,4.2-0.1,8.4-0.7,12.5c-1.4,8.3-8.6,14.1-16.9,13.9 c-8.3-0.1-15.3-5.6-16.3-13.9c-1.3-11.3-1.7-22.8-2.4-34.2c-1.4-23.2-2.7-46.5-4.3-69.7c-1.3-19.5,16.1-33.2,32.6-25.5 C280.4,109,283.6,118.3,282.9,129.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.8,308.5c-12.6-0.3-22.5-10.8-22.2-23.4c0.3-12.3,10.8-22.3,23.2-22.1c12.6,0.2,22.3,10.8,21.9,23.7 C282.2,299,271.9,308.8,259.8,308.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMisedOpportunity01);
export default __webpack_public_path__ + "static/media/mised-opportunity-01.f3ed8b2c19728da223cf28c1f7e11c84.svg";
export { ForwardRef as ReactComponent };